import React from "react";

function QuoteBox({ quoteText, onClose }) {
    if (!quoteText) return null;

    return (
        <div
            className="mb-2 p-2 rounded bg-gray-500 bg-opacity-40 italic text-sm select-none relative"
            style={{ opacity: 0.6, pointerEvents: "auto", color: "#9CA3AF", userSelect: "none" }}
        >
            {/* Close Button */}
            <button
                className="absolute top-1 right-2 text-white text-xl"
                style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    opacity: 1,
                    pointerEvents: "auto",
                }}
                onClick={onClose}
                aria-label="Hủy trả lời"
                type="button"
            >
                &times;
            </button>

            {/* Quote Content */}
            {quoteText.split("\n").map((line, idx) => (
                <div key={idx}>{line}</div>
            ))}
        </div>
    );
}

export default QuoteBox;

